import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import PropTypes from 'prop-types';
export var COLUMN_SHAPE = {
  path: PropTypes.string,
  title: PropTypes.node,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
  type: PropTypes.oneOf(['actions', 'date']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colSpan: PropTypes.number,
  sortable: PropTypes.bool,
  emptyText: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  render: PropTypes.func
};

var Column = function (_React$Component) {
  _inherits(Column, _React$Component);

  var _super = _createSuper(Column);

  function Column() {
    _classCallCheck(this, Column);

    return _super.apply(this, arguments);
  }

  return Column;
}(React.Component);

Column.displayName = 'Table.Column';
Column.defaultProps = {
  path: undefined,
  title: undefined,
  className: undefined,
  align: undefined,
  type: undefined,
  width: undefined,
  colSpan: undefined,
  sortable: false,
  emptyText: false,
  render: undefined
};
export default Column;